export const BLOGS_ACTION_TYPES = {
  FETCH_BLOGS_START: 'BLOGS/FETCH_BLOGS_START',
  FETCH_BLOGS_SUCCESS: 'BLOGS/FETCH_BLOGS_SUCCESS',
  FETCH_BLOGS_FAILED: 'BLOGS/FETCH_BLOGS_FAILED',
};